// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../types';
import configActions from '../../../../actions/configActions';
import { mapConfigSelector } from '../../../../selectors/configSelectors';
import MapConfig from '../MapConfig';
import type { Props } from '../MapConfig';

type OwnProps = $ReadOnly<{
    userType: $PropertyType<Props, 'userType'>
}>;

const mapStateToProps = (state: State) => {
    return {
        mapConfig: mapConfigSelector(state)
    };
};

const mapDispatchToProps = {
    previewMapSource: configActions.previewMapSource
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(MapConfig);